(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("doubleborder-dark-panelless", [], factory);
	else if(typeof exports === 'object')
		exports["doubleborder-dark-panelless"] = factory();
	else
		root["SurveyTheme"] = root["SurveyTheme"] || {}, root["SurveyTheme"]["DoubleborderDarkPanelless"] = factory();
})(this, () => {
return 